import { createFileRoute } from '@tanstack/react-router'

import { TaxonomyCreatePage } from '@/pages/taxonomy/TaxonomyCreate.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies/create',
)({
  component: TaxonomyCreatePage,
  loader: () => ({ breadcrumbTitle: 'Create taxonomy' }),
})
